import { FileCabinetIcon } from './FileCabinetIcon';

/**
 * author: Michael Irigoyen
 * id 1B650467-2000-4A2D-B16D-9BD8A8F32B85
 * name file-cabinet
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-cabinet.svg
 * tags
 * - Files / Folders 
 */
export const FilingCabinetIcon = FileCabinetIcon;
export default FilingCabinetIcon